import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { InitializeAppAction } from '../../store/actions';

@Injectable()
export class DataInitalizationCanActivate  {
  constructor(
    private store: Store
  ) {}

  async canActivate(): Promise<boolean> {
    this.store.dispatch(new InitializeAppAction());
    return true;
  }
}
